/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import MarkdownBody from "@modules/MarkdownBody"
import { formatMarkdownToHtml } from "@helpers/index"
import { rem } from "@src/theme"
import { useDispatch, useSelector } from "react-redux"

export default function SiteBanner() {
  const data = useStaticQuery(
    graphql`
      query {
        pageData: markdownRemark(
          fileAbsolutePath: { glob: "**/globals/banner.md" }
        ) {
          frontmatter {
            text
          }
        }
      }
    `
  )

  const { text } = data.pageData.frontmatter
  const isOpen =
    useSelector(state => state.ui.siteBannerOpen) && text ? true : false

  const dispatch = useDispatch()

  const closeSiteBanner = () => {
    dispatch.ui.closeSiteBanner()
  }

  return (
    <div
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: isOpen ? rem(44.17) : rem(0),
        maxHeight: isOpen ? rem(150) : rem(0),
        transition: "max-height 0.5s ease-in-out",
      }}
    >
      {text && (
        <MarkdownBody
          html={formatMarkdownToHtml(text)}
          sx={{
            bg: "darkPurple",
            color: "white",
            textAlign: "center",
            py: rem(10),
            pr: rem(36),
            pl: rem(10),
            "h1,h2,h3,h4,h5,p,a": {
              my: 0,
              fontSize: rem(16),
              color: "white",
            },
          }}
        />
      )}
      <button
        onClick={closeSiteBanner}
        type="button"
        sx={{
          position: "absolute",
          right: [rem(15), null, rem(45)],
          top: 0,
          height: "100%",
          cursor: "pointer",
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.13127 15.0817L0.304918 12.2554L4.83178 7.7285L0 2.89672L2.89672 0L7.7285 4.83178L12.2554 0.304918L15.0817 3.13127L10.5549 7.65813L15.3866 12.4899L12.4899 15.3866L7.65813 10.5549L3.13127 15.0817Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  )
}
